import styled from 'styled-components'
import { Flex } from '@mantine/core'

export const PriceFundingListCardStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const PriceFundingListCardItemStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  border: 1px var(--color-divider-2) solid;
`

export const PriceFundingListCardItemFooterStyled = styled(Flex)`
  border-top: 1px var(--color-divider-2) solid;
  padding-top: 12px;
`
